<script setup lang="ts">
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { router } from '@inertiajs/vue3'
import { ref, watch } from 'vue'

interface Workshop {
    id: number
    description: string
    start: string
}

const props = defineProps<{
    workshops: Workshop[]
    currentWorkshopId: number | null
}>()

const selected = ref<string>(props.currentWorkshopId ? String(props.currentWorkshopId) : '')

watch(selected, (newValue) => {
    if (!newValue) return
    router.get(window.location.pathname, { workshop_id: Number(newValue) })
})
</script>

<template>
    <Select v-model="selected">
        <SelectTrigger class="bg-white">
            <SelectValue placeholder="Selecione um evento" />
        </SelectTrigger>

        <SelectContent>
            <SelectItem v-for="workshop in workshops" :key="workshop.id" :value="String(workshop.id)">
                {{ workshop.description }}
            </SelectItem>
        </SelectContent>
    </Select>
</template>
